import { Card } from "./Card.jsx";

/**
 * KPI display card. Values render with tabular numerals via the global body
 * font-feature-settings, so numbers in a row of MetricCards align vertically.
 *
 * Props:
 *   label : string                   — "Sessions"
 *   value : number | string          — raw number is toLocaleString'd; strings render as-is
 *   sub   : string (optional)        — "+12.4% vs prior"
 *   trend : "up" | "down" | null     — colors the sub text (positive / negative / muted)
 *   prefix: string (optional)        — e.g. "$"
 *   suffix: string (optional)        — e.g. "%"
 */
export function MetricCard({ label, value, sub, trend, prefix, suffix }) {
  const subColor =
    trend === "up"
      ? "text-positive"
      : trend === "down"
      ? "text-negative"
      : "text-text-muted";

  return (
    <Card className="px-5 py-4">
      <div
        className="text-[11px] uppercase text-text-muted font-medium"
        style={{ letterSpacing: "0.05em" }}
      >
        {label}
      </div>
      <div className="text-[26px] font-semibold text-text-primary mt-2 leading-none">
        {prefix}
        {formatValue(value)}
        {suffix}
      </div>
      {sub && <div className={`text-[11px] mt-2 ${subColor}`}>{sub}</div>}
    </Card>
  );
}

function formatValue(value) {
  if (typeof value === "number") {
    // Show decimals only if present — 475.09 stays 475.09, 6211 stays 6,211.
    return value.toLocaleString("en-US", {
      maximumFractionDigits: 2,
    });
  }
  return value;
}
